import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedWorks() {
  const works = articles.filter((a) => a.category === 'works').slice(0, 3);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-primary-500 text-xs tracking-[0.2em] uppercase mb-2 font-label">Featured Works</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精选作品
            </h2>
          </div>
          <Link
            to="/category/works"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {works.map((work) => (
            <Link
              key={work.id}
              to={`/article/${work.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={work.coverImage}
                  alt={work.title}
                  title={`友田真希 ${work.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <p className="text-xs text-foreground-500 mb-2">{work.date}</p>
                <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {work.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {work.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}